import React from "react";
import { Currency } from "features/shared/enums/currency";
import { formatPrice } from "features/shared/helpers/Formatters";

interface Props {
  amount: number;
  currency: Currency;
  decimalPlaces?: number;
}

const PriceFormatter = (props: Props) => {

  const getFormattedPrice = (amount: number, currency: Currency, decimalPlaces: number = 2) =>
    formatPrice(amount, currency, decimalPlaces);

  return <>{getFormattedPrice(props.amount, props.currency, props.decimalPlaces)}</>;
};

export default PriceFormatter;